import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import RecruiterNavbar from "../components/RecruiterNavbar";
import RecruitersStasGrid from "../components/RecruitersStasGrid";
import RecruiterTable from "../components/RecruiterTable";

const Recruiters = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarStateChange = (isOpen) => {
    setSidebarOpen(isOpen);
  };
  return (
    <div>
      <Sidebar debarStateChange={handleSidebarStateChange} />
      <RecruiterNavbar />
      <RecruitersStasGrid />
      <RecruiterTable />
    </div>
  );
};

export default Recruiters;
